import { defineMessages } from 'react-intl'

const scope = `procurify.components.ChatComment`

export default defineMessages({
  wroteLabel: {
    id: `${scope}.wroteLabel`,
    defaultMessage: 'wrote',
  },
  usernameParseError: {
    id: `${scope}.usernameParseError`,
    defaultMessage:
      'Something went wrong with retrieving comment usernames. Please check that names of users have no special characters.',
  },
})
